import { t } from 'ttag';
import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import { virtualCatalog } from '@urls';
import { tag } from '@legacyUrls';
import { Title } from '@ui/Title';
import { Link } from '@ui/Link';

import s from './ProductDetailsAlsoSearch.sss';

interface CatalogLink {
  catalogSlug: string,
  catalogNamespace: string,
  citySlug?: string | null,
  title: string,
}

interface TagLink {
  tagSlug: string,
  title: string,
}

interface VirtualCatalogLink {
  title: string,
  virtualCatalogSlug: string,
}

interface Props {
  className?: string,
  links: (CatalogLink | TagLink | VirtualCatalogLink)[],
}

export const ProductDetailsAlsoSearch: React.FC<Props> = ({
  className,
  links,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type="h3"
        bold={false}
      >
        {t`Також шукають:`}
      </Title>

      <ul className={s.list}>
        {links.map((link, i) => {
          const isCatalogLink = 'catalogSlug' in link;
          const isTagLink = 'tagSlug' in link;
          const isVirtualCatalogLink = 'virtualCatalogSlug' in link;

          let pathname = null;

          if (isCatalogLink) {
            if (link.citySlug) {
              pathname = `/${link.catalogNamespace}/${link.catalogSlug}/gorod-${link.citySlug}`;
            } else {
              pathname = `/${link.catalogNamespace}/${link.catalogSlug}`;
            }
          } else if (isTagLink) {
            pathname = generatePath(tag, { slug: link.tagSlug });
          } else if (isVirtualCatalogLink) {
            pathname = generatePath(virtualCatalog, { virtualCatalogSlug: link.virtualCatalogSlug });
          }

          if (pathname) {
            return (
              <li
                key={i}
                className={s.item}
              >
                <Link
                  className={s.link}
                  theme='black'
                  to={pathname}
                >
                  {link.title}
                </Link>
              </li>
            );
          }

          return null;
        })}
      </ul>
    </div>
  );
};
